/** @jsxRuntime automatic */
/** @jsxImportSource react */
/**
 * The Pulse rail group's nine pages (docs/CONTRACT-pulse.md; strategy section 9; mockups admin-7 to admin-13, "Build as
 * drawn"), one screen each. App.tsx renders this once the probe says Pulse is on; `canEdit` is false for an auditor, who
 * sees everything read-only (owner, D6: no new role).
 */
import type { PageId } from '../../shell/routes';
import { PulseOverview } from './Overview';
import { PulseAsks } from './Asks';
import { PulseDomains } from './Domains';
import { PulseTools } from './Tools';
import { PulseFeedback } from './Feedback';
import { PulseProblems } from './Problems';
import { PulseDigests } from './Digests';
import { PulseOperations } from './Operations';
import { PulseSettings } from './Settings';

export function PulsePage({ page, canEdit }: { page: PageId; canEdit: boolean }) {
  switch (page) {
    case 'pulse-asks': return <PulseAsks />;
    case 'pulse-domains': return <PulseDomains />;
    case 'pulse-tools': return <PulseTools canEdit={canEdit} />;
    case 'pulse-feedback': return <PulseFeedback canEdit={canEdit} />;
    case 'pulse-problems': return <PulseProblems canEdit={canEdit} />;
    case 'pulse-digests': return <PulseDigests canEdit={canEdit} />;
    case 'pulse-operations': return <PulseOperations />;
    case 'pulse-settings': return <PulseSettings canEdit={canEdit} />;
    default: return <PulseOverview />;
  }
}
